import { graphql } from '~/gql'

const ALL_PRIMARY_USES_QUERY = graphql(`
  query AllPrimaryUsesQuery($forTemplates: Boolean) {
    allPrimaryUses(forTemplates: $forTemplates)
  }
`)

export default ALL_PRIMARY_USES_QUERY
